import { mapMutations, mapGetters } from 'vuex'

export const homework_stat_mix = {
  inject: ['http'],
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    isHomework() {
      return this.$route.params.isHomework ? true : false;
    },
    isHomeworkCompleted() {
      if (this.isHomework) {
        let qnt = +this.$route.params.qnt;
        let total = +this.$route.params.total;
        return total === qnt ? true : false;
      }
    }
  },
  methods: {
    ...mapMutations({
      completeHomework: 'student/completeHomework'
    }),
    checkHomework(stats) {
      console.log('check homework');
      stats.homework_id = this.$route.params.homework_id ? this.$route.params.homework_id : null;
      stats.isHomework = this.isHomework

      this.updateHomework();

      return stats;
    },
    checkCoins(arr) {
      console.log('CHECK COINS', arr);
      if (!arr.coin) return false;

      if (arr.coin.has_coin) {
        swal('Поздравляем! Ты заработал дженкоин!', `Ты два дня подряд выполнял домашнюю работу и за это получаешь Дженкоин!`, 'success');
        let val = {
          param: 'coin_balance',
          value: arr.coin.balance
        };
        this.$store.commit('updateUserParam', val);
      }
    },
    updateHomework() {
      if (!this.$route.params.isHomework) return false;

      let total = +this.$route.params.total;
      let qnt = +this.$route.params.qnt;
      if (total < qnt) total++;
      this.$route.params.total = total;

      let updateParams = { id: this.$route.params.homework_id, date: this.$route.params.date}
      this.completeHomework(updateParams)
    },
    saveStat(data) {
      if (this.user.role.code === 'student') {
        data = this.checkHomework(data);
        this.http.post('onSaveStats', { stat: data }).then((res) => {
          if (this.isHomeworkCompleted) {
            swal('Молодец!', 'тренажер выполнен', 'success')
            this.$router.go(-1)
          }
          this.checkCoins(res.data);
        });
      }      
    },
    checkScoreStatus(scores) {
      if (this.user.role.code === 'student') {
        let all_scores = this.user.scores;
        let user_id = this.user.id;
        let total = all_scores + scores;
        console.log('checkScoreStatus', all_scores, total);
        let arr = {
          user_id: user_id,
          user_scores: total
        }

        if (all_scores === 0 && scores > 0) {
          console.log('Применяем первый статус');
          this.changeUserStatus(arr);
        } else {
          let status = this.user.status;
          if (status) {
            if (status.scores_to <= total) {
              this.changeUserStatus(arr);
            }
          }
        }
      }
    },
    changeUserStatus(arr) {
      console.log('ChangeUserStatus');

      this.http.post('onChangeUserStatus', arr).then(res => {
        console.log(res);
        if (res.data) {
          let status = res.data.title;
          this.$store.commit('updateUserStatus', res.data);
          swal('У тебя новый статус!', `Поздравляем! Ты получаешь статус "${status}"!!!`, "success");
        }
      })
    }
  }
};